import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';
import { useParams, useHistory } from 'react-router-dom';

const getBackgroundColor = (currentStep, index) => {
  if (currentStep === index) return 'purple.500';
  if (currentStep > index) return 'purple.300';
  return 'neutral.100';
};

export const Stepper = ({ steps, slug }) => {
  const { step } = useParams();
  const currentStep = steps.indexOf(step);
  const history = useHistory();

  return (
    <Flex justifyContent="center" alignItems="center" pt="32px">
      {steps.map((name, index) => (
        <Box
          key={name}
          onClick={() => currentStep > index && history.push(`/networks/${slug}/welcome/onboarding/${name}`)}
          sx={{
            height: '8px',
            borderRadius: '9999px',
            transition: 'all 0.3s ease-in-out',
            width: currentStep === index ? '24px' : '8px',
            cursor: currentStep > index ? 'pointer' : 'default',
            backgroundColor: getBackgroundColor(currentStep, index),
            '&:not(:last-child)': {
              marginRight: '8px',
            },
          }}
        />
      ))}
    </Flex>
  );
};

Stepper.propTypes = {
  steps: PropTypes.array.isRequired,
  slug: PropTypes.string.isRequired,
};
